module.exports = __webpack_public_path__ + "media/images/flags/16/Denmark-852b75dde59064f570525dc979dd50fa.png";